import { IconComponentConfig } from 'libs/components/src/lib/utils/icon';

export const WorkflowDiagramInfoIcon: IconComponentConfig = {
  name: 'fa-regular fa-info-circle',
  color: 'var(--text-color)'
};
